export class Input {
  public input: boolean;
  public socket: any;

  constructor() {
    this.input = true;
    this.socket = {};
  }
}
